import type { NotificationEvent } from '@nucleus-commerce/api-client/admin';

/** Store-scoped keys: switching stores never shares cache. */
export const notificationKeys = {
  all: (storeId: string) => ['stores', storeId, 'notification-templates'] as const,
  list: (storeId: string) => [...notificationKeys.all(storeId), 'list'] as const,
  preview: (
    storeId: string,
    event: NotificationEvent,
    draft: { subject: string | null; body: string | null },
  ) => [...notificationKeys.all(storeId), 'preview', event, draft] as const,
};
